module.exports = __webpack_public_path__ + "img/dankort.d63ee40c.svg";